<template>
    <div id="vrm-modal" class="vrm-modal vrm-modal--wysiwyg mfp-with-anim">
        <div class="vrm-modal__header">
            <div class="vrm-modal__title">{{ installationName }}</div>
        </div>
        <div>
            <ckeditor
                v-model="ckdata.editorData"
                :editor="ckdata.editor"
                :config="ckdata.editorConfig"
            ></ckeditor>
        </div>
        <div class="vrm-modal__footer">
            <a class="sg-btn sg-blue pull-right" @click="save()">
                {{ $t('common.save', { i18nFallback: 'Save' }) }}
            </a>
        </div>
        <modal-close-handle />
    </div>
</template>
<style scoped></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { ngInject } from '@/vue/decorators/angular-interop';

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
    components: { ModalCloseHandle, ckeditor: CKEditor.component },
})
@AngularLocaleBundle('modal')
export default class CKeditorMoal extends Vue {
    @ngInject()
    ApiService;
    @Prop({ type: String, default: '' }) installationName;
    @Prop({}) installationId;
    @Prop({ type: String, default: '' }) content;
    @Prop({ type: Object }) installation;

    created() {
        this.ckdata = {
            editor: ClassicEditor,
            editorData: this.content,
            editorConfig: {
                toolbar: [
                    'heading',
                    'bold',
                    'italic',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'numberedList',
                    'bulletedList',
                ],
            },
        };
    }

    save() {
        this.ApiService.installationSettings(this.installationId, {
            notes: this.ckdata.editorData,
        }).then(() => {
            this.installation.notes = this.ckdata.editorData;
        });
        $.magnificPopup.close();
    }
}
</script>
